import React from 'react';

const REACTIONS = ["❤️", "👍", "😂", "🔥", "🎉", "👏", "💯", "✨", "😊", "🙌"];

const ReactionPicker = ({ onSelect, onClose, position = 'top', align = 'left' }) => {
  // Smart positioning: align right if needed to prevent cutoff
  const alignmentClass = align === 'right' ? 'right-0' : 'left-0';
  const verticalClass = position === 'bottom' ? 'top-full mt-1' : 'bottom-full mb-1';
  
  return (
    <div className={`absolute ${verticalClass} ${alignmentClass} bg-gray-800 border border-gray-700 rounded-md shadow-xl p-1.5 z-[9999]`}>
      <div className="flex gap-1">
        {REACTIONS.map((emoji) => (
          <button
            key={emoji}
            onClick={() => {
              onSelect(emoji);
              onClose();
            }}
            className="text-lg hover:scale-110 transition-transform duration-100 p-1 hover:bg-gray-700 rounded"
            title={`React with ${emoji}`}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReactionPicker;
